let baseEventTypesPartTwo = [
  // audit
  'Audit logger requested',
  'Audit logger updated',
  'Audit logs signed',
  'Audit logs verified',
  'Audit logs requested',
  'Audit log list requested',
  // report
  'Timestamp report logs requested',
  'Timestamp report log list requested',
  // system
  'Current time requested',
  'Version info requested',
  'Audit Logger KeyStore activated',
  'Log file list requested',
  'Log file requested',
  'SSL PKCS12 uploaded',
  'NTP stats'
]

export default baseEventTypesPartTwo
